import { useFarms } from '../../hooks/useFarms'

/**
 * @return {any}
 */
export default function Farms() {
  const farms = useFarms()
  return <div>{JSON.stringify(farms)}</div>
}
